import React, { useMemo } from "react"
import "./TimeMachineRail.css"

const MONTHS = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
const YEARS_BACK = 40

export default function TimeMachineRail({ period, onSelect }) {
  const now = new Date()
  const curYear = now.getFullYear()
  const curMonth = now.getMonth() + 1

  const years = useMemo(
    () => Array.from({ length: YEARS_BACK + 1 }, (_, i) => curYear - i),
    [curYear]
  )

  const selYear = period?.year || curYear
  const selMonth = period?.month || curMonth

  // for the current year, only months up to "now"
  const monthCount = selYear === curYear ? curMonth : 12

  const changeYear = (year) => {
    const maxMonth = year === curYear ? curMonth : 12
    onSelect({ year, month: Math.min(selMonth, maxMonth) })
  }

  return (
    <div className="rdate">
      <span className="rdate__label">Released date</span>

      <div className="rdate__year">
        <select value={selYear} onChange={(e) => changeYear(Number(e.target.value))}>
          {years.map((y) => (
            <option key={y} value={y}>{y}</option>
          ))}
        </select>
        <span className="rdate__chev" aria-hidden>▾</span>
      </div>

      <ul className="rdate__months">
        {Array.from({ length: monthCount }, (_, i) => i + 1).map((m) => {
          const isActive = m === selMonth
          return (
            <li key={m}>
              <button
                className={`rdate__month ${isActive ? "is-active" : ""}`}
                onClick={() => onSelect({ year: selYear, month: m })}
              >
                <span className="rdate__dot" />
                {MONTHS[m - 1]}
              </button>
            </li>
          )
        })}
      </ul>
    </div>
  )
}
